import React from 'react';

export const Input = ({ label, required, className = '', labelClassName = '', ...props }) => (
  <div className="mb-5">
    {label && (
      <label
        className={`block text-sm mb-2 text-slate-800 ${labelClassName || 'font-semibold'}`}
      >
        {label} {required && <span className="text-red-500">*</span>}
      </label>
    )}
    <input
      className={`w-full px-3.5 py-3 border border-slate-200/50 rounded-lg text-sm font-sans
        transition-all focus:outline-none focus:border-purple-500 focus:ring-3 focus:ring-purple-200
        placeholder:text-slate-400 ${className}`}
      {...props}
    />
  </div>
);

export const TextArea = ({
  label,
  required,
  characterCount,
  maxLength,
  className = '',
  labelClassName = '',
  ...props
}) => (
  <div className="mb-5">
    {label && (
      <label
        className={`block text-sm mb-2 text-slate-800 ${labelClassName || 'font-semibold'}`}
      >
        {label} {required && <span className="text-red-500">*</span>}
      </label>
    )}
    <textarea
      className={`w-full px-3.5 py-3 border border-slate-200/50 rounded-lg text-sm font-sans
        transition-all focus:outline-none focus:border-purple-500 focus:ring-3 focus:ring-purple-200
        placeholder:text-slate-400 min-h-[100px] resize-y leading-relaxed ${className}`}
      {...props}
    />
    {maxLength !== undefined && characterCount !== undefined && (
      <div className="text-xs text-slate-400 text-right mt-1.5">
        {characterCount} / {maxLength} characters
      </div>
    )}
  </div>
);

export const Select = ({ label, options, className = '', labelClassName = '', ...props }) => (
  <div className="mb-5">
    {label && (
      <label
        className={`block text-sm mb-2 text-slate-800 ${labelClassName || 'font-semibold'}`}
      >
        {label}
      </label>
    )}
    <select
      className={`w-full px-3.5 py-3 border border-slate-200/50 rounded-lg text-sm font-sans
        bg-white cursor-pointer appearance-none bg-no-repeat
        focus:outline-none focus:border-purple-500 focus:ring-3 focus:ring-purple-200 ${className}`}
      style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' stroke='%23737373' viewBox='0 0 24 24'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E")`,
        backgroundPosition: 'right 12px center',
      }}
      {...props}
    >
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  </div>
);

export const Toggle = ({ label, description, checked, onChange, labelClassName = '' }) => (
  <div className="flex items-center justify-between p-4 bg-slate-50 rounded-lg">
    <div className="flex flex-col gap-0.5">
      <span className={`text-sm text-slate-800 ${labelClassName || 'font-semibold'}`}>
        {label}
      </span>
      {description && <span className="text-xs text-slate-400">{description}</span>}
    </div>
    <button
      type="button"
      className={`w-11 h-6 rounded-full relative cursor-pointer transition-all duration-200 border-none
        ${checked ? 'bg-purple-500' : 'bg-slate-200'}`}
      onClick={onChange}
      role="switch"
      aria-checked={checked}
    >
      <span
        className={`absolute w-[18px] h-[18px] bg-white rounded-full top-[3px] transition-all duration-200 shadow
          ${checked ? 'left-[23px]' : 'left-[3px]'}`}
      />
    </button>
  </div>
);

export const FormRow = ({ children }) => (
  <div className="grid grid-cols-2 gap-4">{children}</div>
);
